<template>
    <div class="widget" id="range">
        <h4 class="widgettitle d-flex justify-between" style="margin-top: 20px;">
            {{ trans_title }}
            <div class="toggle-switch range-toggle float-right" style="display: grid;">
                <input type="checkbox" name="type[12]" v-model="range_search" @change="activateDeactivateRange"
                       id="type12"
                       class="toggleCheckbox">
                <label for="type12" class="toggleLabel">On/Off</label>
            </div>
        </h4>
        <div class="background-white p0-20">
            <div class="row flex-center-space" style="background-color: white;">
                <div class="slider-box">
                    <vue-slider
                        :dotStyle="{backgroundColor: '#FFD54F'}"
                        :railStyle="{backgroundColor: '#D6DBDE'}"
                        :processStyle="{backgroundColor: '#D6DBDE'}"
                        :tooltipStyle="{backgroundColor: 'red'}"
                        :min="min_range"
                        :max="max_range"
                        :interval="range_interval"
                        :dot-options="{ tooltip: 'none'}"
                        v-model="range"
                        @change="sliderChanged"
                        ref="slider"
                    />
                </div>
                <div class="float-right value-box">
                    <p class="range-slider-value" :title="hoverMessage()">{{ range }}<br>
                        <span style="font-weight: normal; font-size: 12px;">
                            Km
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <div class="text-center">
            <button class="btn btn-primary mt-10" id="rangeButton" @click="executeSearch">{{
                    filter_btn_trans
                }}
            </button>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import search from '../search';

export default {
    mixins: [
        search,
    ],
    props: {
        trans_title: {
            type: String,
            default: 'Range'
        },
        trans_hover: {
            type: String,
            default: 'Search restaurants within :kms kms'
        },
        filter_btn_trans: {
            type: String,
            default: 'Redefine Search Result'
        }
    },
    components: {
        VueSlider
    },
    data() {
        return {
            default_range: 5,
            range: 5,
            min_range: 1,
            max_range: 50,
            range_interval: 1,
            range_search: false,
        }
    },
    methods: {
        hoverMessage() {
            return this.trans_hover.replace(':kms', this.range);
        },

        sliderChanged() {
            this.range_search = true;

            this.activateDeactivateRange();
        },

        activateDeactivateRange() {
            if (!this.range_search) {
                this.range = this.default_range;
                this.eventHub.$emit('range-ticked', '');
                return;
            }

            this.eventHub.$emit('range-ticked', this.getRange(this.range));
        },

        executeSearch() {
            this.eventHub.$emit('execute-search', 'full');
        },

        resetSearch() {
            this.range = this.default_range;
            this.range_search = false;
        },

        getRange(range) {
            return Math.min(Math.max(range, this.min_range), this.max_range);
        },

        getSearchedRange() {
            let range = this.getUserSearchSessionByType('range');

            if (range.length > 0) {
                this.range_search = true;
                this.range = range[0].value;

                this.eventHub.$emit('range-ticked', this.getRange(this.range + this.default_range));
            }
        }
    },

    created() {
        let self = this;

        this.eventHub.$on('reset_search', () => {
            self.resetSearch();
        });

        this.eventHub.$on('reset_range', () => {
            self.resetSearch();
        });
    },

    mounted() {
        this.getSearchedRange();

        let $vueSliderDot = $('.vue-slider-dot');
        let $vueSliderDotHandle = $('.vue-slider-dot-handle');

        $vueSliderDot.mouseenter(function () {
            $(this).css({
                'border': '2px solid #7F9741',
                'border-radius': '30px',
                'padding': '3px'
            });
        });

        $vueSliderDot.mouseleave(function () {
            $(this).css({
                'border': 'none',
                'padding': 'none'
            });
        });

        $vueSliderDotHandle.mouseup(function () {
            $(this).css('background-color', '#FFD54F');
        });

        $vueSliderDotHandle.mousedown(function () {
            $(this).css('background-color', '#7F9741');
        });
    }
}
</script>

<style scoped>
.value-box {
    padding: 0;
    height: 52px;
    width: 10%;
    margin-left: -90px;
}

.range-slider-value {
    display: inline-block;
    position: relative;
    width: 60px;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    background: #7F9741;
    margin-left: 8px;
    padding: 10px 0 0 0;
}

.range-slider-value:after {
    position: absolute;
    top: 16.5px;
    left: -10px;
    width: 0;
    height: 0;
    border-top: 9px solid transparent;
    border-right: 12px solid #7F9741;
    border-bottom: 9px solid transparent;
    content: '';
}

.p0-20 {
    padding: 0 20px;
}

.vue-slider {
    padding: 7px 0;
    width: 80% !important;
    height: 4px;
    margin-left: -25px;
}

@media (min-width: 768px) and (max-width: 1024px) {

    .vue-slider {
        margin-left: 15px;
        width: 100% !important;
    }

    .value-box {
        margin-left: 13px;
    }

}

@media (min-width: 320px) and (max-width: 480px) {

    .vue-slider {
        width: 93% !important;
    }

    .value-box {
        margin-left: -61px !important;
    }

}

.vue-slider-dot-handle {
    border: 1px solid white !important;
}

.vue-slider-dot-handle:active {
    background-color: #7F9741 !important;
}

.slider-box {
    padding: 0;
    width: 80%;
    display: inline;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/RestaurantSearchRange.vue